import { render, staticRenderFns } from "./BookDetailCheck.vue?vue&type=template&id=9b66948c&scoped=true"
import script from "./BookDetailCheck.vue?vue&type=script&lang=js"
export * from "./BookDetailCheck.vue?vue&type=script&lang=js"
import style0 from "./BookDetailCheck.vue?vue&type=style&index=0&id=9b66948c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b66948c",
  null
  
)

export default component.exports